module.exports = "/img/_/_/_/assets/images/creeper/battle/common//33.jpg?526c19a0be0ad471bff7720b642edef5";